import api from '../apiService';
import { API_ROUTES } from '../constants';
import { PlaybookDto } from './playbookService';

export interface AutomationRuleCreateDto {
  name: string;
  description: string;
  triggerEntity: string;
  triggerEvent: string;
  filter: any; // Using any for JsonNode
  playbookIds: string[];
  active: boolean;
}

export interface AutomationRuleDto {
  ruleId: string;
  tenantId: string;
  name: string;
  description: string;
  triggerEntity: string;
  triggerEvent: string;
  filter: any;
  playbooks: PlaybookDto[];
  playbookIds?: string[];
  active: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface PlaybookRequestDto {
  playbookId: string;
}

const API_BASE_URL = API_ROUTES.AUTOMATION_RULE;

export const automationRuleService = {
  getAllAutomationRules: async () => {
    const response = await api.get<AutomationRuleDto[]>(API_BASE_URL);
    return response.data;
  },

  getAutomationRuleById: async (id: string) => {
    const response = await api.get<AutomationRuleDto>(`${API_BASE_URL}/${id}`);
    return response.data;
  },

  createAutomationRule: async (rule: AutomationRuleCreateDto) => {
    const response = await api.post<AutomationRuleDto>(API_BASE_URL, rule);
    return response.data;
  },

  updateAutomationRule: async (id: string, rule: Partial<AutomationRuleDto>) => {
    const response = await api.patch<AutomationRuleDto>(`${API_BASE_URL}/${id}`, rule);
    return response.data;
  },

  deleteAutomationRule: async (id: string) => {
    await api.delete(`${API_BASE_URL}/${id}`);
  },

  addPlaybookToRule: async (ruleId: string, playbookId: string) => {
    const response = await api.post(`${API_BASE_URL}/${ruleId}/playbooks`, { playbookId });
    return response.data;
  },

  removePlaybookFromRule: async (ruleId: string, playbookId: string) => {
    await api.delete(`${API_BASE_URL}/${ruleId}/playbooks`, { data: { playbookId } });
  },

  getAutomationRuleAuditLogs: async (ruleId: string) => {
    const response = await api.get(`${API_BASE_URL}/${ruleId}/history`);
    return response.data;
  },
};
